var EntityContextService = (function () {
    function EntityContextService($q) {
        this.$q = $q;
        this.defer = this.$q.defer();
    }
    EntityContextService.prototype.subscribe = function () {
        return this.defer.promise;
    };
    EntityContextService.prototype.getContext = function () {
        return this.context;
    };
    EntityContextService.prototype.setContext = function (contextEntity) {
        this.context = contextEntity;
        this.defer.notify(contextEntity);
    };
    return EntityContextService;
}());
export { EntityContextService };
